import {CardEnum} from '@colonist/game-states'
import {GameColor} from '../../../../shared/scripts/GameColor'
import {UIGameCardContainerView} from '../../../../shared/scripts/ui_game/ui_game_card/UIGameCardContainerView'
import {UIGamePopupConfirmationButtons} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupConfirmationButtons'
import {UIGamePopupSelectCardToGiveToPlayer} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupSelectCardToGiveToPlayer'
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'

export class UIMGamePopupSelectCardToGiveToPlayer extends UIGamePopupSelectCardToGiveToPlayer {
    protected createSelectedCardView() {
        const cardContainerY = this.popupImageAndDescription.y + this.popupImageAndDescription.height + this.padding
        const cardContainerH = this.canvas.itemSize * 1.2
        this.selectedCardView = new UIGameCardContainerView(this.uiGameManager, 0, cardContainerY, this.canvas.popupWidth, cardContainerH, this)
        this.selectedCardView.setCardClickAction((cardEnum: CardEnum) => {
            this.clickedSelectedCard(cardEnum)
        })
    }

    protected createPlayerCardContainerView() {
        const cardsToSelectFromW = this.width
        const cardsToSelectFromH = this.canvas.itemSize * 1.2
        const cardsToSelectFromY = UIUtilsEjsVariables.isUserOnTabletApp ? this.canvas.appH - cardsToSelectFromH : this.canvas.appH - this.canvas.bottomViewHeight - this.absoluteHeight + this.height + this.canvas.margin
        this.cardsToSelectFrom = new UIGameCardContainerView(this.uiGameManager, 0, cardsToSelectFromY, cardsToSelectFromW, cardsToSelectFromH, this.canvas.app.stage)
        this.cardsToSelectFrom.drawBg(GameColor.getColorHexValue(GameColor.Color.PrimaryBlue6), 1)
    }

    protected createConfirmationButtons() {
        const bottomButtonH = this.canvas.itemSize
        const confirmationButtonY = this.absoluteHeight - bottomButtonH
        this.confirmationButtons = new UIGamePopupConfirmationButtons(0, confirmationButtonY, this.canvas.popupWidth, bottomButtonH,
            () => this.clickedCheckAction(), () => this.cancelAction(), this)
    }

    destroy() {
        this.uiGameManager.mapController.mapView.off('pointerdown', this.cancelAction)
        super.destroy()
    }

    protected setContainerY() {
        const canvas = this.uiGameManager.canvasController
        const spaceFromBottom = canvas.bottomViewHeight
        this.y = this.canvas.appH - spaceFromBottom - this.absoluteHeight
    }
}
